import { RadioGroupProps } from "@amzn/awsui-components-console";

import { ProcessCartAction } from "@/components/cart/types";

export const actionItems: RadioGroupProps["items"] = [
  {
    value: ProcessCartAction.UPDATE,
    label: "Add to an existing collection",
    description:
      "This will add to an existing collection made from this application.",
  },
  {
    value: ProcessCartAction.CREATE,
    label: "Create a new collection",
    description: "This will create a collection in Iconik.",
  },
];
